/*
 * @Author: your name
 * @Date: 2021-01-31 11:26:20
 * @LastEditTime: 2021-01-31 11:38:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /marmot_design_ui/src/components/upload/img-upload/img.upload.tsx
 */
import React, { Component } from "react";
import FileUpload, { iProps } from "./index";
interface imgUploadProps extends iProps {
  value?: any[];
}
export default class ImgUpload extends Component<imgUploadProps> {
  render() {
    let { props = {} } = this;
    return <FileUpload fileList={this.props.value} {...props}></FileUpload>;
  }
}
